import React from "react";
import { Button, TabPane } from "reactstrap";
import { DASHBOARD_USER_ROLES } from "../../../../constants";
import { useAppName } from "../../../../slices/theme/hooks";

const WelcomeStep = ({ toggleVerticalTab, currentUser, welcomeStep }) => {
  const appName = useAppName();


  const roleMessages = {
    [DASHBOARD_USER_ROLES.BROKER]:
      `Thank you for being a part of the ${appName} team! Use this portal to add and manage your employer groups, employees, individuals and commissions. Click the button below to get started.`,
    [DASHBOARD_USER_ROLES.EMPLOYER]:
      "It's time to set up your very own prescription benefit program! Click the button below to get started.",
    [DASHBOARD_USER_ROLES.NATIONAL]:
      `Thank you for being a part of the ${appName} team! Use this portal to add and manage your GA's, brokers, employer groups, employees, individuals and commissions. Click the button below to get started.`,
    [DASHBOARD_USER_ROLES.GA]:
      `Thank you for being a part of the ${appName} team! Use this portal to add and manage your brokers, employer groups, employees, individuals and commissions. Click the button below to get started.`,
  };

  return (
    <TabPane tabId={welcomeStep}>
      <div className="d-flex justify-content-center align-items-center py-3 flex-column">
        <div className=" text-center ">
          <h3 className="fw-semibold  text-dark">Welcome to {appName}</h3>
          <p className="fw-normal fs-5 mt-3">
            {roleMessages[currentUser.role]}{" "}
          </p>
        </div>

        <div className="text-center d-flex justify-content-center mt-3">
          <Button
            color="primary"
            onClick={() => toggleVerticalTab(welcomeStep + 1)}
            className="btn btn-primary d-flex align-items-center py-0 px-3  "
          >
            Get Started
            <i className="ri-arrow-right-line ms-1 fs-2"></i>
          </Button>
        </div>
      </div>
    </TabPane>
  );
};

export default WelcomeStep;
